import makeUseStyles from "@/core/ui/style/util/makeUseStyles"
import { UserCardSkeleton } from "@/product/member/common/card/UserCard"
import { Skeleton } from "@material-ui/lab"

function ProductMembersListSkeleton() {
  const classes = useStyles()

  return (
    <div>
      <Skeleton width={150} height={40} />
      <div className={classes.container}>
        <UserCardSkeleton />
        <UserCardSkeleton />
        <UserCardSkeleton />
      </div>
    </div>
  )
}

const useStyles = makeUseStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
}))

export default ProductMembersListSkeleton
